export type CategoryEditorialFields = {
  h1Title?: string
  introParagraph?: string
  publicDescription?: string
  summary1?: string
  summary2?: string
  quickTip?: string
}

export const CATEGORY_EDITORIAL_FIELDS = [
  'h1Title',
  'introParagraph',
  'publicDescription',
  'summary1',
  'summary2',
  'quickTip',
] as const

export function readCategoryEditorialFields(source: Record<string, unknown>): CategoryEditorialFields {
  const text = (value: unknown) => (typeof value === 'string' ? value : undefined)
  return {
    h1Title: text(source.h1_title),
    introParagraph: text(source.intro_paragraph),
    publicDescription: text(source.public_description),
    summary1: text(source.summary_1),
    summary2: text(source.summary_2),
    quickTip: text(source.quick_tip),
  }
}
